import React, { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import {
  fetchBrandCustomData,
  updateBrandCustomData,
  deleteBrandCustomData,
} from '../../actions/settings/brandCustomData';
import { getSelectedBrandCode } from '../../selectors/brand/brandSelector';
import BrandCustomData from '../../components/body/settings/BrandCustomData';
import { intercomEvent } from '../../utils/IntercomUtils';
import { ApplicationState } from '../../reducers';
import { AsyncDispatch } from '../../../types/global';
import { withContainerWrapper } from '../ContainerWrapper';
import { useAppDispatch } from '../../store/ReduxStore';
import { BrandCustomData as BrandCustomDataType } from '../../../types/brand_settings';

const SettingsBrandCustomDataContainer: React.FC = () => {
  const dispatch: AsyncDispatch = useAppDispatch();

  const { brandCustomData, loading, brandCode, brandId } = useSelector(
    (state: ApplicationState) => {
      return {
        brandCustomData: state.settings.brandCustomData.data,
        loading: state.settings.brandCustomData.loading,
        brandCode: getSelectedBrandCode(state),
        brandId: state.parent.brands.selectedBrandId,
      };
    },
    shallowEqual
  );

  useEffect(() => {
    if (brandId) {
      intercomEvent('viewed-brand-settings', {
        location: 'settings-brand-custom-data',
        brand_code: brandCode!,
      });
      dispatch(fetchBrandCustomData(brandId));
    }
  }, [brandCode, brandId, dispatch]);

  const handleSave = async (customData: BrandCustomDataType[]) => {
    if (brandId) {
      await dispatch(updateBrandCustomData(brandId, customData));
      dispatch(fetchBrandCustomData(brandId));
    }
  };

  const handleDelete = async (customDataFieldId: number) => {
    if (brandId) {
      await dispatch(deleteBrandCustomData(brandId, customDataFieldId));
    }
  };

  return (
    <BrandCustomData
      data={brandCustomData}
      loading={loading}
      onSave={handleSave}
      onDelete={handleDelete}
    />
  );
};

export default withContainerWrapper(SettingsBrandCustomDataContainer);
